import React, { useState } from 'react';
import { CauseImage, HomeAbout, HomeCauses, HomeDonate, HomeFame, HomeFooter, HomeMap, HomeMission, HomeProcesses, HomeServices, SlideModel } from '../../components';
import { useDisclosure, Modal, ModalContent, ModalOverlay } from '@chakra-ui/react'
import { useFlutterwave } from 'react-flutterwave';
import { paymentConfig } from '../../utils/constants/payments/flutterwaveConfig'
const Home = () => {
    const { isOpen, onOpen, onClose } = useDisclosure()
    var _paymentConfig = paymentConfig;
    const handleFlutterPayment = useFlutterwave(_paymentConfig);
    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [amount, setAmount] = useState(0)
    return (
        <div>
            {/* <!--Start main Banner Area--> */}
            <div className="main-banner-area">
                <div className="container-fluid">
                    <div className="row align-items-center">
                        <div className="col-lg-6 col-md-12">
                            <div className="d-table">
                                <div className="d-table-cell">
                                    <div className="main-banner-content">
                                        {/* <span>Child Hope</span> */}
                                        <div style={{ height: '21px' }}></div>
                                        <h1>“If you can’t feed a hundred people, then feed just one.”</h1><span>— Mother Teresa</span>
                                        <p>
                                            We are inspired by selfless citizens such as Mother Theresa who walked and lived a life of service to the less fortunate in society.
                                        </p>
                                        <div className="banner-btn" >
                                            <a className="default-btn" href="#"  onClick={onOpen} >
                                                Donate Now
                                                <i className="flaticon-right"></i>
                                                
                                            </a>
                                            <a className="optional-btn" href="#" >
                                                Become Member
                                                <i className="flaticon-right"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                            <div className="banner-slider-wrap">
                                <div className="banner-image-slider owl-carousel owl-theme owl-loaded owl-drag">
                                    <div className="owl-stage-outer">
                                        <div className="owl-stage"
                                            style={{ transform: 'translate3d(-1226px, 0px, 0px)', transition: 'all 1s ease 0s', width: '4904px' }}>
                                            <div className="owl-item" style={{ width: "613px" }}>
                                                <div className="image-item">
                                                    <img src="assets/img/3.png" alt="image" />
                                                </div>
                                            </div>
                                            <div className="owl-item" style={{ width: "613px" }}>
                                                <div className="image-item">
                                                    <img src="assets/img/2.png" alt="image" />
                                                </div>
                                            </div>
                                            <div className="owl-item" style={{ width: "613px" }} >
                                                <div className="image-item">
                                                    <img src="assets/img/1.png" alt="image" />
                                                </div>
                                            </div>
                                            <div className="owl-item" style={{ width: "613px" }}>
                                                <div className="image-item">
                                                    <img src="assets/img/2.png" alt="image" />
                                                </div>
                                            </div>
                                            <div className="owl-item" style={{ width: "613px" }}>
                                                <div className="image-item">
                                                    <img src="assets/img/3.png" alt="image" />
                                                </div>
                                            </div>
                                            <div className="owl-item" style={{ width: "613px" }}>
                                                <div className="image-item">
                                                    <img src="assets/img/2.png" alt="image" />
                                                </div>
                                            </div>
                                            <div className="owl-item" style={{ width: "613px" }}>
                                                <div className="image-item">
                                                    <img src="assets/img/1.png" alt="image" />
                                                </div>
                                            </div>
                                            <div className="owl-item" style={{ width: "613px" }}>
                                                <div className="image-item">
                                                    <img src="assets/img/2.png" alt="image" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="owl-nav">
                                        <button type="button" role="presentation" className="owl-prev">
                                            <i className="flaticon-left"></i>
                                        </button>
                                        <button type="button" role="presentation" className="owl-next">
                                            <i className="flaticon-right"></i>
                                        </button>
                                    </div>
                                    <div className="owl-dots disabled"></div>
                                </div>
                                <div className="banner-video">
                                    <a href="https://www.youtube.com/watch?v=uemObN8_dcw" className="video-btn popup-youtube"
                                        savefrom_lm_index="0" savefrom_lm="1">
                                        <i className="bx bx-play"></i>
                                    </a>
                                    <span style={{ padding: '0', margin: '0', marginLeft: '5px' }}>
                                        <a href="http://savefrom.net/?url=https%3A%2F%2Fwww.youtube.com%2Fwatch%3Fv%3DuemObN8_dcw&amp;utm_source=chameleon&amp;utm_medium=extensions&amp;utm_campaign=link_modifier"
                                            target="_blank" title="Get a direct link" savefrom_lm="1" savefrom_lm_is_link="1"
                                            style={{ backgroundImage: 'url(&quot;data:image/gif;base64,R0lGODlhEAAQAOZ3APf39+Xl5fT09OPj4/Hx8evr6/3+/u7u7uDh4OPi497e3t7e3/z8/P79/X3GbuXl5ubl5eHg4WzFUfb39+Pj4lzGOV7LOPz7+/n6+vn5+ZTLj9/e387Ozt7f3/7+/vv7/ISbePn5+m/JV1nRKXmVbkCnKVrSLDqsCuDh4d/e3uDn3/z7/H6TdVeaV1uSW+bn5v39/eXm5eXm5kyHP/f39pzGmVy7J3yRd9/f3mLEKkXCHJbka2TVM5vaZn6Wdfn6+YG/c/r5+ZO/jeLi41aHTIeageLn4f39/vr6+kzNG2PVM5i+lomdf2CXYKHVmtzo2YXNeDqsBebl5uHh4HDKWN3g3kKqEH6WeZHTXIPKdnSPbv79/pfmbE7PHpe1l4O8dTO5DODg4VDLIlKUUtzo2J7SmEWsLlG4NJbFjkrJHP7+/VK5Nfz8+zmnC3KKa+Hg4OHh4Y63j/3+/eDg4Ojo6P///8DAwP///wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACH5BAEAAHcALAAAAAAQABAAAAfWgHd2g4SFhYJzdYqLjIpzgx5bBgYwHg1Hk2oNDXKDFwwfDF5NLmMtcStsn4MhGT8YS04aGmU1QRhIGYMTADQAQlAODlloAMYTgwICRmRfVBISIkBPKsqDBAREZmcVFhYVayUz2IMHB1dWOmImI2lgUVrmgwUFLzdtXTxKSSduMfSD6Aik48MGlx05SAykM0gKhAAPAhTB0oNFABkPHg5KMIBCxzlMQFQZMGBIggSDpsCJgGDOmzkIUCAIM2dOhEEcNijQuQDHgg4KOqRYwMGOIENIB90JBAA7&quot;)', backgroundRepeat: 'no-repeat', width: '16px', height: '16px', display: 'inline-block', border: 'none', textDecoration: 'none', padding: '0px', position: 'relative' }}></a>
                                    </span>
                                    <span>Watch Intro</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="banner-text">
                        <p>
                            The fund will go to the poor...
                    <span onClick={onOpen} >Donate Now</span>
                        </p>
                    </div>
                    <div className="banner-shape">
                        <img src="assets/img/shapes/shape.png" alt="" />
                    </div>
                </div>

            </div>
            <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
                <ModalContent>
                    <form className="donate-form">
                        <div className="row">
                            <div className="col-lg-6 col-md-6">
                                <div className="form-group">
                                    <input type="text" name="name" className="form-control" placeholder="Your Full Name " onChange={e => setName(e.target.value)} />
                                </div>
                            </div>

                            <div className="col-lg-6 col-md-6">
                                <div className="form-group">
                                    <div className="select-box">
                                        <select className="form-control">
                                            <option value="5">Your Country</option>
                                            <option value="1">China</option>
                                            <option value="2">United Kingdom</option>
                                            <option value="0">Germany</option>
                                            <option value="3">France</option>
                                            <option value="4">Japan</option>

                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-12">
                                <div className="form-group">
                                    <div className="form-group">
                                        <input type="text" name="email" className="form-control" placeholder="Your email" onChange={e => setEmail(e.target.value)} />
                                    </div>
                                    <div className="select-box">
                                        <select className="form-control" onChange={e => setAmount(e.target.value)}>
                                            <option value="400">$400</option>
                                            <option value="500">$500</option>
                                            <option value="600">$600</option>
                                            <option value="50">$50</option>
                                            <option value="1000">$1000</option>
                                            <option value="100">$100</option>
                                        </select>
                                        <span className="usd">$ USD</span>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-12">
                                <div className="donate-form-btn">
                                    <a  href="#" className="default-btn" onClick={
                                        () => {
                                            _paymentConfig.amount = amount;
                                            _paymentConfig.customer.email = email;
                                            _paymentConfig.customer.name = name;
                                            handleFlutterPayment({
                                                callback: (response) => {
                                                    console.log(response);
                                                },
                                                onClose: () => {

                                                },
                                            });
                                        }
                                    }>
                                        Donate Your Money
                                        <span></span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </form>

                </ModalContent>

            </Modal>
            <HomeServices />
            <HomeAbout />
            <HomeCauses />
            <HomeProcesses />
            <HomeDonate />
            <HomeMission />
            <HomeFame />
            <HomeMap />
            <section className="mission-area bg-background">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="mission-tab mission-tab-three">
                                <span>
                                    <i className="flaticon-target"></i>
                            Our Mission
                        </span>

                                <h2>Concern about Our Mission</h2>

                                <div className="tab mission-list-tab">
                                    <ul className="tabs active">
                                        <li className="current">
                                            <a href="#">
                                                Our Mission
                                    </a>
                                        </li>
                                        <li>
                                            <a href="#">
                                                Our Vision
                                    </a>
                                        </li>
                                        <li>
                                            <a href="#">
                                                Our Goal
                                    </a>
                                        </li>
                                    </ul>

                                    <div className="tab_content">
                                        <div className="tabs_item">
                                            <p>The organization envisions to eradicate poverty by providing the skill and knowledge to the under privileged children of the society and and to the needy refugees and orphans that are coming from war torn countries to reside in Uganda. </p>

                                            <p>They will be equipped to recognize and use resources around them for their holistic empowerment.</p>
                                            <a className="default-btn"
                                                href="#">
                                                Our Mission
                                        <span></span>
                                                <i className="flaticon-right"></i>
                                            </a>
                                        </div>

                                        <div className="tabs_item">
                                            <p>To see a healthy, stable, gender balanced, prosperous and productive society that living in a conducive environment. </p>
                                            <a className="default-btn"
                                                href="#">
                                                Our Mission
                                        <span></span>
                                                <i className="flaticon-right"></i>
                                            </a>
                                        </div>

                                        <div className="tabs_item">
                                            <p>To identify, tap and optimally harness the potential of the under – privileged children of the city of Kampala and Uganda in such a way as to strike a judicious balance between their own quality of life as well as towards their meaningful contribution to the society/nation. </p>

                                            <a className="default-btn"
                                                href="#">
                                                Our Mission
                                        <span></span>
                                                <i className="flaticon-right"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="white-shape">
                    <img src="./assets/img/white-shape.png" alt="Image" />
                </div>
            </section>
            <section className="team-section pt-100 pb-70">
                <div className="container">

                    <div className="section-title">
                        <span>
                            <i className="flaticon-support"></i>
                    Meet Our Team
                </span>
                        <h2>Volunteers Around The Globe</h2>
                        <p>Child Hope’s Senior Leadership Team, Volunteers and each and every staff member are dedicated to the belief that every child in Uganda and around the world deserves a future. </p>
                    </div>

                    <div className="row">
                        <div className="col-lg-3 col-sm-6">
                            <div className="single-team-member-two">
                                <div className="team-image">
                                    <CauseImage image="assets/img/team/jolly.jpg" title="Jolly Bwengye" />
                                    <ul className="social-btn">
                                        <li>
                                            <a href="_">
                                                <i className="flaticon-plus"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="_">
                                                <i className="flaticon-twitter"></i>
                                            </a>
                                        </li>

                                        <li>
                                            <a href="_">
                                                <i className="flaticon-instagram"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="_">
                                                <i className="flaticon-facebook"></i>
                                            </a>
                                        </li>
                                    </ul>
                                </div>

                                <div className="member-content">
                                    <h3>Jolly Bwengye </h3>
                                    <span>Program Manager</span>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-sm-6">
                            <div className="single-team-member-two">
                                <div className="team-image">
                                    <CauseImage image="assets/img/team/james.jpg" title="James Bwengye" />
                                    <ul className="social-btn">
                                        <li>
                                            <a href="_">
                                                <i className="flaticon-plus"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="_">
                                                <i className="flaticon-twitter"></i>
                                            </a>
                                        </li>

                                        <li>
                                            <a href="_">
                                                <i className="flaticon-instagram"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="_">
                                                <i className="flaticon-facebook"></i>
                                            </a>
                                        </li>
                                    </ul>
                                </div>

                                <div className="member-content">
                                    <h3>James Bwengye</h3>
                                    <span>CEO &amp; Director</span>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-sm-6">
                            <div className="single-team-member-two">
                                <div className="team-image">
                                    <CauseImage image="assets/img/team/sam.jpg" title="Samuel Agaba" />

                                    <ul className="social-btn">
                                        <li>
                                            <a href="_">
                                                <i className="flaticon-plus"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="_">
                                                <i className="flaticon-twitter"></i>
                                            </a>
                                        </li>

                                        <li>
                                            <a href="_">
                                                <i className="flaticon-instagram"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="_">
                                                <i className="flaticon-facebook"></i>
                                            </a>
                                        </li>
                                    </ul>
                                </div>

                                <div className="member-content">
                                    <h3>Agaba Samuel</h3>
                                    <span>Director</span>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-sm-6">
                            <div className="single-team-member-two">
                                <div className="team-image">
                                    <CauseImage image="assets/img/team/14.png" title="Wycliff Mugabe" />

                                    <ul className="social-btn">
                                        <li>
                                            <a href="_">
                                                <i className="flaticon-plus"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="_">
                                                <i className="flaticon-twitter"></i>
                                            </a>
                                        </li>

                                        <li>
                                            <a href="_">
                                                <i className="flaticon-instagram"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="_">
                                                <i className="flaticon-facebook"></i>
                                            </a>
                                        </li>
                                    </ul>
                                </div>

                                <div className="member-content">
                                    <h3>Wycliff Mugabe </h3>
                                    <span>Director</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
     {/*        <section className="event-section pt-100">
                <div className="container">
                    <div className="section-title">
                        <span>
                            <i className="flaticon-clipboard"></i>
                    Upcoming Events
                </span>
                        <h2>Be ready for Our Events</h2>
                        <p>In order to raise funds, Child Hope conducts fundraising events which initiates an annual fund search, as well as an annual banquet/ barbecue. Keep on the lookout for this year’s upcoming events in order to participate and join our cause.</p>
                    </div>

                    <div className="event-slider owl-carousel owl-theme owl-loaded owl-drag">
                        <div className="owl-stage-outer">
                            <div className="owl-stage"
                                style={{ transform: 'translate3d(-2850px, 0px, 0px)', transition: 'all 1s ease 0s', width: '4560px' }}>
                                <div className="owl-item cloned" style={{ width: '540px', marginRight: '30px' }}>
                                    <div className="event-item">
                                        <div className="row">
                                            <div className="col-lg-4">
                                                <div className="event-time">
                                                    <h3>0-130</h3>
                                                    <span>5 December 2020</span>

                                                    <div className="icon">
                                                        <i className="flaticon-clock"></i>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-lg-8">
                                                <div className="event-content">
                                                    <h4>Post COVID-19 Donation</h4>

                                                    <ul className="event-meta">
                                                        <li>
                                                            <i className="flaticon-clock"></i>
                                                    8:00 - 10:00
                                                </li>

                                                        <li>
                                                            <i className="flaticon-pin"></i>
                                                    Bwaise
                                                </li>
                                                    </ul>
                                                    <p>Dona ques suspendice consectetucaquuis ipsums gravida.</p>
                                                    <a href="#"
                                                        className="event-btn-one">Join Now +</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="owl-item cloned" style={{ width: '540px', marginRight: '30px' }}>
                                    <div className="event-item">
                                        <div className="row">
                                            <div className="col-lg-4">
                                                <div className="event-time">
                                                    <h3>0-140</h3>
                                                    <span>10 January 2021</span>

                                                    <div className="icon">
                                                        <i className="flaticon-clock"></i>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-lg-8">
                                                <div className="event-content">
                                                    <h4>Poor funding for helpless</h4>

                                                    <ul className="event-meta">
                                                        <li>
                                                            <i className="flaticon-clock"></i>
                                                    9:00 - 12:00
                                                </li>

                                                        <li>
                                                            <i className="flaticon-pin"></i>
                                                    Wandegeya
                                                </li>
                                                    </ul>
                                                    <p>Suspendice quis ipsum consectetucaquuis ipsums gravida.</p>
                                                    <a href="#"
                                                        className="event-btn-one">Join Now +</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="owl-item" style={{ width: '540px', marginRight: '30px' }}>
                                    <div className="event-item">
                                        <div className="row">
                                            <div className="col-lg-4">
                                                <div className="event-time">
                                                    <h3>0-130</h3>
                                                    <span>5 December 2020</span>

                                                    <div className="icon">
                                                        <i className="flaticon-clock"></i>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-lg-8">
                                                <div className="event-content">
                                                    <h4>Childhope Con Donation 2020</h4>

                                                    <ul className="event-meta">
                                                        <li>
                                                            <i className="flaticon-clock"></i>
                                                    8:00 - 10:00
                                                </li>

                                                        <li>
                                                            <i className="flaticon-pin"></i>
                                                    Karamoja
                                                </li>
                                                    </ul>
                                                    <p>Dona ques suspendice consectetucaquuis ipsums gravida.</p>
                                                    <a href="#"
                                                        className="event-btn-one">Join Now +</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="owl-item" style={{ width: '540px', marginRight: '30px' }}>
                                    <div className="event-item">
                                        <div className="row">
                                            <div className="col-lg-4">
                                                <div className="event-time">
                                                    <h3>0-140</h3>
                                                    <span>10 January 2021</span>

                                                    <div className="icon">
                                                        <i className="flaticon-clock"></i>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-lg-8">
                                                <div className="event-content">
                                                    <h4>Poor funding for helpless</h4>

                                                    <ul className="event-meta">
                                                        <li>
                                                            <i className="flaticon-clock"></i>
                                                    9:00 - 12:00
                                                </li>

                                                        <li>
                                                            <i className="flaticon-pin"></i>
                                                    Calfornia City
                                                </li>
                                                    </ul>
                                                    <p>Suspendice quis ipsum consectetucaquuis ipsums gravida.</p>
                                                    <a href="#"
                                                        className="event-btn-one">Join Now +</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="owl-item" style={{ width: '540px', marginRight: '30px' }}>
                                    <div className="event-item">
                                        <div className="row">
                                            <div className="col-lg-4">
                                                <div className="event-time">
                                                    <h3>0-130</h3>
                                                    <span>5 December 2020</span>

                                                    <div className="icon">
                                                        <i className="flaticon-clock"></i>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-lg-8">
                                                <div className="event-content">
                                                    <h4>Childhope Donation 2020</h4>

                                                    <ul className="event-meta">
                                                        <li>
                                                            <i className="flaticon-clock"></i>
                                                    8:00 - 10:00
                                                </li>

                                                        <li>
                                                            <i className="flaticon-pin"></i>
                                                    Karamoja
                                                </li>
                                                    </ul>
                                                    <p>Dona ques suspendice consectetucaquuis ipsums gravida.</p>
                                                    <a href="#"
                                                        className="event-btn-one">Join Now +</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="owl-item active" style={{ width: '540px', marginRight: '30px' }}>
                                    <div className="event-item">
                                        <div className="row">
                                            <div className="col-lg-4">
                                                <div className="event-time">
                                                    <h3>0-140</h3>
                                                    <span>10 January 2021</span>

                                                    <div className="icon">
                                                        <i className="flaticon-clock"></i>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-lg-8">
                                                <div className="event-content">
                                                    <h4>Poor funding for helpless</h4>

                                                    <ul className="event-meta">
                                                        <li>
                                                            <i className="flaticon-clock"></i>
                                                    9:00 - 12:00
                                                </li>

                                                        <li>
                                                            <i className="flaticon-pin"></i>
                                                    Wandegeya
                                                </li>
                                                    </ul>
                                                    <p>Suspendice quis ipsum consectetucaquuis ipsums gravida.</p>
                                                    <a href="#"
                                                        className="event-btn-one">Join Now +</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="owl-item cloned active" style={{ width: '540px', marginRight: '30px' }}>
                                    <div className="event-item">
                                        <div className="row">
                                            <div className="col-lg-4">
                                                <div className="event-time">
                                                    <h3>0-130</h3>
                                                    <span>5 December 2021</span>

                                                    <div className="icon">
                                                        <i className="flaticon-clock"></i>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-lg-8">
                                                <div className="event-content">
                                                    <h4>Childhope Con Donation 2021</h4>

                                                    <ul className="event-meta">
                                                        <li>
                                                            <i className="flaticon-clock"></i>
                                                    8:00 - 10:00
                                                </li>

                                                        <li>
                                                            <i className="flaticon-pin"></i>
                                                    Karamoja
                                                </li>
                                                    </ul>
                                                    <p>Dona ques suspendice consectetucaquuis ipsums gravida.</p>
                                                    <a href="#"
                                                        className="event-btn-one">Join Now +</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="owl-item cloned" style={{ width: '540px', marginRight: '30px' }}>
                                    <div className="event-item">
                                        <div className="row">
                                            <div className="col-lg-4">
                                                <div className="event-time">
                                                    <h3>0-140</h3>
                                                    <span>10 January 2021</span>

                                                    <div className="icon">
                                                        <i className="flaticon-clock"></i>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-lg-8">
                                                <div className="event-content">
                                                    <h4>Poor funding for helpless</h4>

                                                    <ul className="event-meta">
                                                        <li>
                                                            <i className="flaticon-clock"></i>
                                                    9:00 - 12:00
                                                </li>

                                                        <li>
                                                            <i className="flaticon-pin"></i>
                                                   Kampala
                                                </li>
                                                    </ul>
                                                    <p>Suspendice quis ipsum consectetucaquuis ipsums gravida.</p>
                                                    <a href="#"
                                                        className="event-btn-one">Join Now +</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="owl-nav disabled">
                            <button type="button" role="presentation" className="owl-prev">
                                <i className="flaticon-left"></i>
                            </button>
                            <button type="button" role="presentation" className="owl-next">
                                <i className="flaticon-right"></i>
                            </button>
                        </div>
                        {/* <!-- <div className="owl-dots">
                    <button role="button" className="owl-dot">
                        <span></span>
                    </button>
                    <button role="button" className="owl-dot active">
                        <span></span>
                    </button>
                </div> --> 
                    </div>
                </div>
            </section> 
            <section className="testimonials-section pt-140 pb-100">
                <div className="container">
                    <div className="section-title">
                        <span>
                            <i className="flaticon-testimonial"></i>
                    Testimonials
                </span>
                        <h2>Don’t Believe Us? See review</h2>
                    </div>

                    <div className="row border-hide">
                        <div className="testimonials-slider-two owl-carousel owl-theme owl-loaded owl-drag">

                            <div className="owl-stage-outer">
                                <div className="owl-stage"
                                    style={{ transform: 'translate3d(-1755px, 0px, 0px)', transition: 'all 1s ease 0s', width: '3510px' }}>
                                    <div className="owl-item" style={{ width: '555px', marginRight: '30px' }}>
                                        <div className="testimonials-area-content">
                                            <h3>Precious Journey with you”</h3>
                                            <p>Every works inton sit amet consectetur adipisicing elit, sed do eiusmod
                                            tempor incididunt ut aliqua. Ut enim ad will not be et dolore magna aliqua.
                                            Ut enim ad will not be does.
                                    </p>

                                            <div className="info">
                                                <img src="/assets/img/client/1.jpg" alt="Morgan Ando" />
                                                <div className="kkk">
                                                    <h3>Morgan Ando</h3>
                                                    <span>Ustino Charity Canada</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="owl-item" style={{ width: '555px', marginRight: '30px' }}>
                                        <div className="testimonials-area-content">
                                            <h3>Precious Journey with you”</h3>
                                            <p>Every works inton sit amet consectetur adipisicing elit, sed do eiusmod
                                            tempor incididunt ut aliqua. Ut enim ad will not be et dolore magna aliqua.
                                        Ut enim ad will not be does.</p>

                                            <div className="info">
                                                <img src="/assets/img/client/2.jpg" alt="Morgan Ando" />
                                                <div className="kkk">
                                                    <h3>Juhan Luis</h3>
                                                    <span>Charity Bingo UK</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="owl-item" style={{ width: '555px', marginRight: '30px' }}>
                                        <div className="testimonials-area-content">
                                            <h3>Precious Journey with you”</h3>
                                            <p>Every works inton sit amet consectetur adipisicing elit, sed do eiusmod
                                            tempor incididunt ut aliqua. Ut enim ad will not be et dolore magna aliqua.
                                        Ut enim ad will not be does.</p>

                                            <div className="info">
                                                <img src="/assets/img/client/1.jpg" alt="Morgan Ando" />
                                                <div className="kkk">
                                                    <h3>Morgan Ando</h3>
                                                    <span>Ustino Charity Canada</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="owl-item" style={{ width: '555px', marginRight: '30px' }}>
                                        <div className="testimonials-area-content">
                                            <h3>Precious Journey with you”</h3>
                                            <p>Every works inton sit amet consectetur adipisicing elit, sed do eiusmod
                                            tempor incididunt ut aliqua. Ut enim ad will not be et dolore magna aliqua.
                                        Ut enim ad will not be does.</p>

                                            <div className="info">
                                                <img src="/assets/img/client/2.jpg" alt="Morgan Ando" />
                                                <div className="kkk">
                                                    <h3>Juhan Luis</h3>
                                                    <span>Charity Bingo UK</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="owl-item" style={{ width: '555px', marginRight: '30px' }}>
                                        <div className="testimonials-area-content">
                                            <h3>Precious Journey with you”</h3>
                                            <p>Every works inton sit amet consectetur adipisicing elit, sed do eiusmod
                                            tempor incididunt ut aliqua. Ut enim ad will not be et dolore magna aliqua.
                                        Ut enim ad will not be does.</p>

                                            <div className="info">
                                                <img src="/assets/img/client/1.jpg" alt="Morgan Ando" />
                                                <div className="kkk">
                                                    <h3>Morgan Ando</h3>
                                                    <span>Ustino Charity Canada</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="owl-item" style={{ width: '555px', marginRight: '30px' }}>
                                        <div className="testimonials-area-content">
                                            <h3>Precious Journey with you”</h3>
                                            <p>Every works inton sit amet consectetur adipisicing elit, sed do eiusmod
                                            tempor incididunt ut aliqua. Ut enim ad will not be et dolore magna aliqua.
                                        Ut enim ad will not be does.</p>

                                            <div className="info">
                                                <img src="/assets/img/client/2.jpg" alt="Morgan Ando" />
                                                <div className="kkk">
                                                    <h3>Juhan Luis</h3>
                                                    <span>Charity Bingo UK</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="owl-nav disabled">
                                <button type="button" role="presentation" className="owl-prev">
                                    <i className="flaticon-left"></i>
                                </button>
                                <button type="button" role="presentation" className="owl-next">
                                    <i className="flaticon-right"></i>
                                </button>
                            </div>
                            <div className="owl-dots disabled"></div>
                        </div>
                    </div>
                </div>
            </section>*/} 
            <section className="donate-section ptb-100">
                <div className="container">
                    <div className="section-title">
                        <h2>Want you know How Can Help?</h2>
                        <p>Child Hope provides alternative ways in which you can contribute to the restoration of a traumatized child’s life. Whether you give financially, volunteer, or foot a sponsorship, your generosity means the world in the life of a child</p>
                        <a href="#" className="donate-btn">
                            Become A Volunteer
                    <i className="flaticon-right"></i>
                        </a>
                    </div>
                </div>
                <div className="default-shape">
                    <img src="./assets/img/donate/1.png" alt="Donate" />
                    <img src="./assets/img/donate/2.png" alt="Donate" />
                </div>
            </section>

            <HomeFooter />
        </div>


    )

}


export default Home;
